import MessageAttachments from './MessageAttachments';

export default MessageAttachments;
